import APIClient from '@/shared/http/clients/api'

const resourceName = 'REComissaoParcela'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetParcelas = (id, data, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/${id}`, data, config)

const CommissionshareRepository = {
  GetParcelas
}

export default CommissionshareRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/commissionshare.js